import styled from "styled-components";


export const StyledProgressbar = styled.div`
  padding: 7px 20px;
  margin: 0 auto;
  background: #000000;
  position: relative;
  border-radius: 4px;
  text-align: center;
  color: white;
  &:after {
    content: "";
    position: absolute;
    bottom: -7px;
    left: 50%;
    margin-left: -9px;
    width: 15px;
    height: 15px;
    background: #000000;
    transform: rotate(45deg);
  }
`;

export const StyledProgressbarWrapper = styled.div`
  background: white;
  padding: 2px 2px;
  z-index: 2;
  position: relative;
  margin-top: 8px;
`;
